import React, { useState } from 'react';
import { X, Save } from 'lucide-react';

import TaskFields from './TaskFields';


const TaskSetupModal = ({ task:initialTask, onUpdateTask, onCancelTask, onSaveTask }) => {

  const [pendingTask, setPendingTask] = useState(initialTask);

  const handleTaskUpdate = (updatedTask) => {
    setPendingTask(updatedTask);

    if (onUpdateTask) {
      onUpdateTask(updatedTask);
    }
  };

  const handleCancelTask = () => {
    setPendingTask(null);

    if (onCancelTask) {
      onCancelTask();
    }
  };

  const handleSaveTask = () => {
    setPendingTask(null);

    if (onSaveTask) {
      onSaveTask();
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
      <div className="relative bg-white rounded-lg p-4 w-[600px] max-w-4xl max-h-[60vh] flex flex-col">
        <div className="space-y-6 flex-grow overflow-y-auto">
          <TaskFields 
            task={pendingTask} 
            onUpdateTask={handleTaskUpdate} 
            ampSection="Task Setup Modal"
          />
        </div>

        <div className="flex justify-end items-center gap-2">
          <button 
            onClick={handleCancelTask}
            data-amp-track-section="Task Setup Modal"
            data-amp-track-action="Cancel_Click"
            data-amp-track-description="Cancel Task Setup"
            className="flex items-center gap-2 bg-transparent text-stone-700 hover:bg-stone-200 rounded-lg p-2">
            <X size={22} /> Cancel
          </button>
          <button 
            onClick={handleSaveTask}
            data-amp-track-section="Task Setup Modal"
            data-amp-track-action="Save_Click"
            data-amp-track-description="Save Task Setup"
            className="flex items-center gap-2 bg-transparent text-stone-700 hover:bg-stone-200 rounded-lg p-2">
            <Save size={22} /> Save & Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default TaskSetupModal;

